import { styled } from "@stitches/react";

const NavList = styled("ul", {});

export { NavList };
